import WhatIncludedInPrice from './WhatIncludedInPrice';

export default WhatIncludedInPrice;
